<template>
  <div style="overflow-x: scroll">
    <br />
    <vs-row>
      <vs-spacer />
      <vs-button
        color="success"
        class="btnSub"
        @click="tableToExcel()"
        type="filled"
        >Download</vs-button
      ></vs-row
    ><br />
    <div id="table_report"></div>

    <br />
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import { read, utils, writeFileXLSX } from "xlsx";
export default {
  props: ["items"],
  data: () => ({
    num: 0,
    table: "testTable",
    name: "W3C Example Table",
    sum: {},
    data_sensor: [],
    total_row: {},
    keydata: [
      { heder: "MDB-EX1", key: "Active_power", sum: 0 },
      "",
      "",
      { total: true },
      "",
      { total: true },
      "",
      { total: true },
      "",
      "",
      "",
      { total: true },
      "",

      { total: true },
      "",
      { total: true },
      "",
      "",
    ],
    items: [],
  }),
  methods: {
    tableToExcel() {
      this.num = "";
      const wb = { SheetNames: [], Sheets: {} };
      this.items.message.data.forEach((value, index) => {
        wb.SheetNames.push(value.date);
        wb.Sheets[value.date] = XLSX.utils.table_to_book(
          document.getElementById("testTable" + value.date)
        ).Sheets.Sheet1;
      });
      const blob = new Blob(
        [this.s2ab(XLSX.write(wb, { bookType: "xlsx", type: "binary" }))],
        {
          type: "application/octet-stream",
        }
      );
      var link = document.createElement("a");

      link.href = window.URL.createObjectURL(blob);
      // link.download =
      //   "Electric consumption (kW-h) of EX1 substation of " +
      //   this.items.message.date +
      //   ".xlsx";
      link.download = "EX1.xlsx";
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
    },
    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
    createTable() {
      let div = document.getElementById("table-report");
      let header;
      let table_obj = "";
      this.items.message.data.forEach((item) => {
        if (item.sum == undefined) {
          let date = item.date;
          let year = item.year;
          header =
            '<tr><td colspan="22">Electric consumption (kW-h) of EX1 substation</td></tr>' +
            "<tr><td></td><td>Month :</td><td >" +
            date +
            "</td><td >" +
            year +
            '</td><td colspan="19"></td></tr>' +
            '<tr><td rowspan="3">Date</td><td colspan="2">MDB-EX1</td><td colspan="2"></td><td colspan="2"></td><td colspan="2"></td><td colspan="2"></td><td colspan="2"></td><td colspan="2"></td><td colspan="2"></td><td colspan="2"></td></tr>' +
            "<tr><td>Recording</td><td>Exiting</td><td>Recording</td><td>Exiting</td><td>Recording</td><td>Exiting</td><td>Recording</td><td>Exiting</td><td>Recording</td><td>Exiting</td><td>Recording</td><td>Exiting</td><td>Recording</td><td>Exiting</td><td>Recording</td><td>Exiting</td><td>Recording</td><td>Exiting</td></tr>" +
            "<tr><td>data</td><td>cons.</td><td>data</td><td>cons.</td><td>data</td><td>cons.</td><td>data</td><td>cons.</td><td>data</td><td>cons.</td><td>data</td><td>cons.</td><td>data</td><td>cons.</td><td>data</td><td>cons.</td><td>data</td><td>cons.</td></tr>";
          // console.log(item);
          let tr = "";
          item.data.forEach((day, day_i) => {
            // console.log(day, day_i);
            let td_key = "";
            let tr_row = "";
            let td_date = "<td>" + day.date + "</td>";
            td_key += td_date;
            let td_sp1 = td_date;
            let total = 0;
            this.keydata.forEach((key, key_i) => {
              let check_value = 0;
              day.data.forEach((data, data_i) => {
                // console.log(data);
                if ([key.heder].includes(data.name)) {
                  td_sp1 = "<td>" + data.data[key.key] + "</td>";
                  td_key += td_sp1;
                  check_value = 1;
                  if (key.total == true) {
                    total += parseFloat(data.data[key.key]);
                  }
                }
                if (day.data.length - 1 == data_i && check_value == 0) {
                  if (key.total == false) {
                    td_sp1 = "<td>" + total + "</td>";
                  } else {
                    td_sp1 = "<td>" + 0 + "</td>";
                  }
                  td_key += td_sp1;
                  check_value = 0;
                }
                // console.log(td_key);
              });
            });
            tr_row += "<tr>" + td_key + "</tr>";
            tr += tr_row;
            // console.log(tr_row);
          });
          let tr_percent =
            '<tr><td>%</td><td id="total"></td><td colspan="2"></td><td colspan="2"></td><td colspan="2"></td><td colspan="2"></td><td colspan="2"></td><td colspan="2"></td><td colspan="2"></td><td colspan="2"></td><td colspan="2"></td></tr>';
          let tr_bottom =
            ' <tr><td colspan="22">&nbsp;</td></tr>' +
            '<tr><td rowspan="3">&nbsp;</td><td rowspan="3"></td><td rowspan="3"></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>' +
            "<tr><td>&nbsp;</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>" +
            "<tr><td>&nbsp;</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>" +
            "<tr><td>Reporter</td><td>SV</td><td>Div Mgr</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>";

          let table =
            '<table id="testTable' +
            item.date +
            '" style="width: 100%" summary="Code page support in different versions of MS Windows." rules="groups"><tbody align="center" frame="hsides" border="2">' +
            header +
            tr +
            tr_percent +
            tr_bottom +
            "</tbody></table><br/><br/>";
          // console.log(table);
          // console.log(tr);
          table_obj += table;
          // div.appendChild(table);
          // document.getElementById("reportaji").innerHTML = 'asdafa';

          // console.log(tr);
        }
        // }
      });
      document.getElementById("table_report").innerHTML = table_obj;
    },
  },
  mounted() {
    this.createTable();
  },
  watch: {
    items: {
      // watch it
      handler(newValue, oldValue) {
        this.createTable();
        this.keydata = [
          { heder: "MDB-EX1", key: "Active_power", sum: 0 },
          "",
          "",
          { total: true },
          "",
          { total: true },
          "",
          { total: true },
          "",
          "",
          "",
          { total: true },
          "",

          { total: true },
          "",
          { total: true },
          "",
          "",
        ];
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" >
#table_report {
  table,
  td,
  th {
    border: 1px solid #111111;
    border-collapse: collapse;
    font-size: 15px;
  }
}
</style>

<style scoped>
table,
td,
th {
  border: 1px solid #111111;
  border-collapse: collapse;
  font-size: 15px;
}
/* td, th {
	padding: 3px;
	width: 30px;
	height: 25px;
} */
th {
  background: #f0e6cc;
}
.even {
  background: #fbf8f0;
}
.odd {
  background: #fefcf9;
}
.btnSub {
  width: 100px;
  border-radius: 20px;
}
.cardRadi {
  border-radius: 20px;
}
</style>